export default "__VITE_ASSET__BBfkoheU__"